import type { KeyboardEvent, RefObject } from "react";
import classNames from "classnames";

export interface SearchInputProps {
  autoFocus?: boolean;
  disabled?: boolean;
  handleOpen: () => void;
  onKeyDown?: (event: KeyboardEvent<HTMLInputElement>) => void;
  onSearchChange: (searchValue: string) => void;
  placeholder?: string;
  searchInputRef: RefObject<HTMLInputElement>;
  searchValue: string;
}

export const SearchInput = ({
  searchInputRef,
  onSearchChange,
  placeholder,
  searchValue,
  handleOpen,
  onKeyDown,
  disabled = false,
  autoFocus = false,
}: SearchInputProps) => (
  <input
    onFocus={handleOpen}
    ref={searchInputRef}
    value={searchValue}
    placeholder={placeholder}
    disabled={disabled}
    className={classNames(
      "search-input placeholder:text-light placeholder:opacity-100 disabled:cursor-not-allowed disabled:opacity-50",
      {
        "!bg-secondary cursor-not-allowed": disabled,
      },
    )}
    onChange={event => {
      event.stopPropagation();
      handleOpen();
      onSearchChange(event.target.value);
    }}
    autoCapitalize="false"
    autoComplete="false"
    onKeyDown={onKeyDown}
    autoFocus={autoFocus}
  />
);
